/** Cmd admin alert audio assets (served from /public/sounds). */
export const ALERT_SOUND_URLS = {
  milestone: '/sounds/milestone.wav',
  recoveryDetected: '/sounds/recovery-detected.wav',
  recoveryAlert: '/sounds/recovery-alert.mp3',
  recovery: '/sounds/recovery-alert.mp3',
  newToken: '/sounds/new-token.wav',
};

let activeAudio = null;

/**
 * Play a named alert sound at the given volume (0–1).
 * Returns a Promise that resolves with approximate duration in ms.
 */
export function playAlertSound(soundType, volume = 0.8) {
  const src = ALERT_SOUND_URLS[soundType];
  if (!src) {
    return Promise.resolve(500);
  }

  return new Promise((resolve, reject) => {
    try {
      if (activeAudio) {
        try {
          activeAudio.pause();
          activeAudio.currentTime = 0;
        } catch (_) { /* ignore */ }
        activeAudio = null;
      }

      const audio = new Audio(src);
      activeAudio = audio;
      audio.volume = Math.max(0, Math.min(1, Number(volume) || 0));

      const finish = (ms) => {
        if (activeAudio === audio) activeAudio = null;
        resolve(ms);
      };

      audio.addEventListener('ended', () => finish(Math.round((audio.duration || 0.5) * 1000)), { once: true });
      audio.addEventListener('error', () => {
        if (activeAudio === audio) activeAudio = null;
        reject(new Error(`Failed to load alert sound: ${soundType}`));
      }, { once: true });

      const playPromise = audio.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.catch((err) => {
          if (activeAudio === audio) activeAudio = null;
          reject(err);
        });
      }

      // Fallback clear if metadata never loads / duration unknown
      audio.addEventListener('loadedmetadata', () => {
        const ms = Math.max(300, Math.round((audio.duration || 1) * 1000));
        setTimeout(() => {
          if (activeAudio === audio) activeAudio = null;
        }, ms + 100);
      }, { once: true });
    } catch (err) {
      reject(err);
    }
  });
}

export function stopAlertSound() {
  if (!activeAudio) return;
  try {
    activeAudio.pause();
    activeAudio.currentTime = 0;
  } catch (_) { /* ignore */ }
  activeAudio = null;
}
